import { UploadFileUserPayload } from 'app/api/user'
import { getFormData } from 'app/utils/formUtils'
import { fileValidation } from 'app/utils/validationUtils'
import * as Yup from 'yup'
export type InputHolderDocumentFormData = {
  input_holder?: FileList | null
}

export const inputHolderDefaultValues: InputHolderDocumentFormData = {
  input_holder: null,
}

export const inputHolderValidationSchema = Yup.object().shape({
  input_holder: fileValidation({
    isRequired: true,
  }),
})

export const adaptFormDataToAPI = (
  formData: InputHolderDocumentFormData
): FormData => {
  const data: UploadFileUserPayload = {
    file: formData.input_holder as FileList,
    type: 'identity_document',
  }
  return getFormData({ formData: data })
}
